import { createSlice, createAction } from '@reduxjs/toolkit'

const initUser = {
    id: '',
    sessionId: null,
    age: null,
    gender: '',
    demographic: '',
    bots_owned: [],
    recent_activities: '',
    username: null
}

const userReducer = createSlice({
    name: 'user',
    initialState: initUser,
    reducers: {
        login: (state, action) => {
            // console.log("received action", action)
            state.id = action.payload.id
            state.sessionId = action.payload.sessionId
            if (action.payload.hasOwnProperty("age") && typeof action.payload.age === "number") {
                state.age = action.payload.age
            }
            if (action.payload.hasOwnProperty("gender") && typeof action.payload.gender === "string") {
                const validGenders = ["Male", "Female"]
                if (validGenders.includes(action.payload.gender)) {
                    state.gender = action.payload.gender;
                }
            }
            // Check and update demographic
            if (action.payload.hasOwnProperty("demographic") && typeof action.payload.demographic === "string") {
                state.demographic = action.payload.demographic;
            }
            // Check and update bots_owned
            if (action.payload.hasOwnProperty("bots_owned") && Array.isArray(action.payload.bots_owned)) {
                state.bots_owned = action.payload.bots_owned;
            }
            // Check and update recent_activities
            if (action.payload.hasOwnProperty("recent_activities") && typeof action.payload.recent_activities === "string") {
                state.recent_activities = action.payload.recent_activities;
            }
            // Check and update username
            if (action.payload.hasOwnProperty("username") && typeof action.payload.username === "string") {
                state.username = action.payload.username;
            }

            // return action.payload
            return
        },
        update: state => {

        },
        logout: state => {
            return initUser
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createAction("RESET_REDUCER"), (state, action) => {
                // console.log("user reducer receives action", action)
                state = initUser
            })
            .addDefaultCase((state, action) => {
                state = initUser
            })
    },
})

// Action creators are generated for each case reducer function
export const { login, update, logout } = userReducer.actions

export default userReducer.reducer